
import withRootContext from 'context/withRootContextHOC'
import { useServiceScheduleContext } from 'src/context/serviceScheduleContext'

import FormSteps from 'src/components/formSteps'
import PageContainer from 'src/components/pageContainer'
import WarningModal from 'src/components/warningModal'

import { formatPrice } from 'utils'
import SchedulingReview from '../../schedulingReview'

import { assetPrefix } from 'src/config/env_config'

import * as S from './styles'

const ReviewStep = (props) => {
  const { context } = props
  const { state: { modal, scheduleBody, formList }, functions } = useServiceScheduleContext()
  const {
    handleWarningModalClose,
    pricesInfo
  } = functions
  const {
    totalPriceWithDiscount
  } = pricesInfo()

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps show={false} context={context} finalStep>
        <S.PageContainer>
          <S.AlignWrappers>
            <S.WrapperTitle>
              <span>Revise seu agendamento</span>
            </S.WrapperTitle>
            <SchedulingReview current schedule={scheduleBody} />
            {
              formList?.map((scheduling, index) => {
                return (
                  <SchedulingReview key={'scheduling-' + index} schedule={scheduling.body} previousState={scheduling} />
                )
              })
            }
            {!!formList.length &&
              <S.CalcPrice>
                <img src={`${assetPrefix}/static/icons/money-outline.svg`} />
                <div>Total</div>
                <S.Total>
                  {formatPrice(totalPriceWithDiscount)}
                </S.Total>
              </S.CalcPrice>}
          </S.AlignWrappers>
        </S.PageContainer>
      </FormSteps>

      <WarningModal
        visible={!!modal}
        cancelLabel={modal?.cancelLabel}
        confirmLabel={modal?.confirmLabel}
        type={modal?.type}
        title={modal?.title}
        subtitle={modal?.subtitle}
        onConfirm={modal?.onConfirm}
        onCancel={modal?.onCancel || handleWarningModalClose}
        fullButton={modal?.fullButton}
        outlineCancelButton={modal?.outlineCancelButton}
        showClose={modal?.showClose}
        icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
        iconSize={modal?.iconSize}
        dataTest='modal-warning-scheduling'
      >
        {modal?.body}
      </WarningModal>
    </PageContainer>
  )
}

export default withRootContext(ReviewStep)
